import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

const IMG = {
  steak: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  dessert: "https://images.unsplash.com/photo-1590741664176-7fbd7e2592a0?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  risotto: "https://images.unsplash.com/photo-1621494268492-d01b98eba7e4?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  secondo: "https://images.unsplash.com/photo-1546964124-0cce460f38ef?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  vino: "https://images.unsplash.com/photo-1610458034932-dc165f29499e?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  cocktail: "https://images.unsplash.com/photo-1683744129482-2cdd6645ed29?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
};

const CATS_FOOD = [
  { name: "Antipasti", cover: IMG.steak, dishes: [
    { n: "Tartare di manzo", p: "14,00", img: IMG.steak, all: [1, 3] },
    { n: "Burrata e alici", p: "12,00", img: IMG.dessert, all: [7] },
  ] },
  { name: "Primi", cover: IMG.risotto, dishes: [
    { n: "Tagliolini al tartufo", p: "18,00", img: IMG.risotto, all: [1, 3, 7] },
    { n: "Risotto ai funghi porcini", p: "16,00", img: IMG.risotto, all: [7] },
  ] },
  { name: "Secondi", cover: IMG.secondo, dishes: [
    { n: "Filetto al pepe verde", p: "24,00", img: IMG.secondo, all: [7] },
    { n: "Tagliata di manzo", p: "22,00", img: IMG.secondo, all: [] },
  ] },
  { name: "Dolci", cover: IMG.dessert, dishes: [
    { n: "Tiramisù della casa", p: "7,00", img: IMG.dessert, all: [1, 3, 7] },
    { n: "Panna cotta ai frutti di bosco", p: "6,00", img: IMG.dessert, all: [7] },
  ] },
];

const CATS_DRINK = [
  { name: "Vini", cover: IMG.vino, dishes: [
    { n: "Chianti Classico DOCG", p: "6,00", img: IMG.vino, all: [] },
    { n: "Franciacorta Brut", p: "8,00", img: IMG.vino, all: [] },
  ] },
  { name: "Bevande & Cocktail", cover: IMG.cocktail, dishes: [
    { n: "Spritz", p: "7,00", img: IMG.cocktail, all: [] },
    { n: "Negroni", p: "9,00", img: IMG.cocktail, all: [] },
  ] },
];

const CATS = CATS_FOOD;

const MENUS = [
  { name: "Menu", sub: "La nostra carta completa", cover: IMG.steak, cats: CATS_FOOD },
  { name: "Menù del Giorno", sub: "Le proposte di oggi", cover: IMG.risotto, cats: [CATS_FOOD[1], CATS_FOOD[2]] },
  { name: "Drink List", sub: "Vini, bevande e cocktail", cover: IMG.vino, cats: CATS_DRINK },
];

const DEFAULT_ACCENT = "#B2A475";
const THEME_COLORS = ["#B2A475", "#1F6F54", "#2C5282", "#7C2020", "#B9722E"];
const voci = (n) => `${n} ${n === 1 ? "voce" : "voci"}`;

const PhoneDemo = () => {
  const [plan, setPlan] = useState("full"); // free | full
  const [accent, setAccent] = useState(DEFAULT_ACCENT);
  const [menuIdx, setMenuIdx] = useState(null);
  const [catIdx, setCatIdx] = useState(null);
  const isFull = plan === "full";
  const switchPlan = (k) => { setPlan(k); setMenuIdx(null); setCatIdx(null); };

  const activeMenu = menuIdx != null ? MENUS[menuIdx] : null;
  const activeCats = activeMenu ? activeMenu.cats : CATS;

  return (
    <div className="w-full flex flex-col items-center">
      <div className="inline-flex rounded-full p-1 mb-6" style={{ backgroundColor: "rgba(255,255,255,0.06)", border: "1px solid rgba(178,164,117,0.25)" }} data-testid="plan-toggle">
        {[["free", "Gratis"], ["full", "Abbonamento"]].map(([k, lbl]) => (
          <button key={k} onClick={() => switchPlan(k)} data-testid={`plan-${k}`}
            className="text-sm font-semibold rounded-full px-5 py-1.5 transition-all"
            style={plan === k ? { backgroundColor: accent, color: "#0B0B0C" } : { color: "rgba(245,241,230,0.6)" }}>
            {lbl}
          </button>
        ))}
      </div>

      <div className="relative w-full max-w-[300px] aspect-[9/19] rounded-[2.4rem] p-2.5 shadow-2xl" style={{ background: "linear-gradient(160deg,#2a2a2a,#0d0d0d)", border: "1px solid rgba(178,164,117,0.35)" }}>
        <div className="absolute top-2.5 left-1/2 -translate-x-1/2 w-24 h-5 bg-black rounded-b-2xl z-20" />
        <div className="relative w-full h-full rounded-[1.9rem] overflow-hidden flex flex-col" style={{ backgroundColor: "#0B0B0C" }} data-testid="phone-screen">

          {isFull ? (
            /* ================= ABBONAMENTO ================= */
            menuIdx == null ? (
              /* ---- Hub: selezione menù ---- */
              <div data-testid="phone-hub" className="flex flex-col h-full">
                <div className="pt-7 px-4 text-center flex-shrink-0" style={{ background: "linear-gradient(180deg,rgba(178,164,117,0.14),transparent)" }}>
                  <div className="flex justify-center gap-2 mb-3" data-testid="phone-lang">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold" style={{ border: `1.5px solid ${accent}`, color: accent }}>IT</span>
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold" style={{ border: "1px solid rgba(255,255,255,0.2)", color: "rgba(245,241,230,0.4)" }}>GB</span>
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold" style={{ border: "1px solid rgba(255,255,255,0.2)", color: "rgba(245,241,230,0.4)" }}>DE</span>
                  </div>
                  <img src={LOGO_URL} alt="logo" className="w-12 h-12 object-contain mx-auto" />
                  <p className="mt-1 font-medium text-xl" style={{ fontFamily: "'Cormorant Garamond', serif", color: accent }}>Trattoria Demo</p>
                  <div className="mx-auto mt-2 mb-1 h-px w-12" style={{ background: `linear-gradient(90deg,transparent,${accent},transparent)` }} />
                  <div className="flex justify-center gap-2 mt-2" data-testid="phone-theme-picker">
                    {THEME_COLORS.map((c) => (
                      <button key={c} onClick={() => setAccent(c)} data-testid={`phone-theme-${c.replace("#", "")}`} className="w-5 h-5 rounded-full transition-transform hover:scale-110" style={{ backgroundColor: c, boxShadow: accent === c ? "0 0 0 2px #0B0B0C, 0 0 0 3px rgba(255,255,255,0.85)" : "0 0 0 1px rgba(255,255,255,0.2)" }} />
                    ))}
                  </div>
                  <p className="text-[8px] mt-1" style={{ color: "rgba(245,241,230,0.4)" }}>Anteprima tema · scegli un colore</p>
                  <p className="text-[10px] uppercase tracking-[0.25em] mt-3 mb-1" style={{ color: "rgba(245,241,230,0.55)" }}>I nostri menù</p>
                </div>
                <div className="flex-1 overflow-y-auto px-3 pb-2 pt-2 space-y-3">
                  {MENUS.map((m, i) => (
                    <button key={m.name} onClick={() => setMenuIdx(i)} data-testid={`phone-menu-${i}`} className="block w-full rounded-2xl overflow-hidden text-left transition-transform active:scale-[0.97]" style={{ border: `1px solid ${accent}33` }}>
                      <div className="relative h-28">
                        <img src={m.cover} alt={m.name} className="w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(11,11,12,0.94), rgba(11,11,12,0.25) 70%)" }} />
                        <div className="absolute bottom-2.5 left-3 right-3">
                          <span className="block text-lg font-medium text-white leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{m.name}</span>
                          <span className="text-[10px]" style={{ color: accent }}>{m.sub}</span>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
                <div className="py-2 text-center text-[9px] flex-shrink-0" style={{ color: "rgba(245,241,230,0.35)", borderTop: "1px solid rgba(255,255,255,0.06)" }}>Powered by Diamond Innovations</div>
              </div>
            ) : catIdx == null ? (
              /* ---- Categorie del menù selezionato ---- */
              <div data-testid="phone-cats" className="flex flex-col h-full">
                <div className="pt-7 pb-2 px-4 flex-shrink-0 relative" style={{ background: "linear-gradient(180deg,rgba(178,164,117,0.12),transparent)" }}>
                  <button onClick={() => setMenuIdx(null)} data-testid="phone-back-hub" className="absolute left-3 top-7 flex items-center" style={{ color: accent }}><ChevronLeft className="w-5 h-5" /></button>
                  <p className="text-center font-medium text-lg" style={{ fontFamily: "'Cormorant Garamond', serif", color: accent }}>{activeMenu.name}</p>
                </div>
                <div className="flex-1 overflow-y-auto px-3 pb-2 space-y-3">
                  {activeCats.map((c, i) => (
                    <button key={c.name} onClick={() => setCatIdx(i)} data-testid={`phone-cat-${i}`} className="block w-full rounded-2xl overflow-hidden text-left transition-transform active:scale-[0.97]" style={{ border: `1px solid ${accent}33` }}>
                      <div className="relative h-24">
                        <img src={c.cover} alt={c.name} className="w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(11,11,12,0.92), transparent 70%)" }} />
                        <div className="absolute bottom-2 left-3 right-3 flex items-end justify-between">
                          <span className="text-base font-medium text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{c.name}</span>
                          <span className="text-[10px]" style={{ color: accent }}>{voci(c.dishes.length)}</span>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              /* ---- Piatti ---- */
              <DishView cats={activeCats} catIdx={catIdx} onBack={() => setCatIdx(null)} isFull accent={accent} />
            )
          ) : (
            /* ================= GRATIS ================= */
            catIdx == null ? (
              <div className="flex flex-col h-full">
                <div className="pt-9 px-4 text-center flex-shrink-0">
                  <p className="font-medium text-lg" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#c9c9c9" }}>Trattoria Demo</p>
                </div>
                <div className="flex-1 overflow-y-auto px-3 pt-4 space-y-2.5">
                  {CATS.map((c, i) => (
                    <button key={c.name} onClick={() => setCatIdx(i)} data-testid={`phone-cat-${i}`} className="w-full rounded-lg px-4 py-3 flex items-center justify-between text-left transition-transform active:scale-[0.98]" style={{ backgroundColor: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)" }}>
                      <span className="text-sm" style={{ color: "#e6e6e6" }}>{c.name}</span>
                      <ChevronRight className="w-4 h-4" style={{ color: "#8b8b8b" }} />
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <DishView cats={CATS} catIdx={catIdx} onBack={() => setCatIdx(null)} isFull={false} accent={accent} />
            )
          )}
        </div>
      </div>

      <p className="mt-4 text-xs text-center max-w-[300px]" style={{ color: "rgba(245,241,230,0.4)" }}>
        {isFull ? "Abbonamento: più menù, foto vere dei piatti, tema premium, più lingue e allergeni." : "Gratis: menù essenziale, tema fisso, senza foto né traduzioni."}
      </p>
    </div>
  );
};

const DishView = ({ cats, catIdx, onBack, isFull, accent }) => (
  <div className="flex flex-col h-full">
    <div className="pt-7 pb-2 px-4 flex-shrink-0 relative" style={{ background: isFull ? "linear-gradient(180deg,rgba(178,164,117,0.12),transparent)" : "transparent" }}>
      <button onClick={onBack} data-testid="phone-back" className="absolute left-3 top-7 flex items-center" style={{ color: isFull ? accent : "#8b8b8b" }}><ChevronLeft className="w-5 h-5" /></button>
      <p className="text-center font-medium text-lg" style={{ fontFamily: "'Cormorant Garamond', serif", color: isFull ? accent : "#c9c9c9" }}>{cats[catIdx].name}</p>
    </div>
    <div className="flex-1 overflow-y-auto px-3 pb-3 space-y-3">
      {cats[catIdx].dishes.map((d, i) => (
        <div key={i} className="rounded-xl overflow-hidden" style={{ backgroundColor: "rgba(255,255,255,0.04)", border: `1px solid ${isFull ? "rgba(178,164,117,0.25)" : "rgba(255,255,255,0.08)"}` }}>
          {isFull ? (
            <img src={d.img} alt={d.n} className="w-full h-24 object-cover" />
          ) : (
            <div className="w-full h-9 flex items-center justify-center text-[10px]" style={{ backgroundColor: "rgba(255,255,255,0.03)", color: "rgba(245,241,230,0.3)" }}>Foto non disponibile</div>
          )}
          <div className="p-3">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm text-[#F5F1E6]">{d.n}</span>
              <span className="text-sm font-semibold" style={{ color: isFull ? accent : "#9a9a9a" }}>€ {d.p}</span>
            </div>
            {isFull && d.all && (
              <div className="flex gap-1 mt-1.5">
                {d.all.map((a) => (<span key={a} className="w-4 h-4 rounded-full text-[9px] flex items-center justify-center" style={{ border: `1px solid ${accent}`, color: accent }}>{a}</span>))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PhoneDemo;
